import React, { memo } from "react";
import { Stack } from "investira.react.components";
import { DataProcessAnimation } from "../../../components/molecules";

const ConsultaProcess = memo(() => {
  return (
    <Stack
      flexGrow={1}
      justifyContent="center"
      alignItems="center"
      sx={{ minHeight: "calc(100% - 220px)" }}
    >
      <DataProcessAnimation />
    </Stack>
  );
});

export default ConsultaProcess;
